import service from "@/services/facturacion/bitacora";

const getDefaultState = () => ({});

// export const namespaced = true

export const state = () => getDefaultState();

export const mutations = {};

export const actions = {
  downloadXML: (_, id) => service.downloadXML(id),
};

export const getters = {};
